module.exports = __webpack_public_path__ + "static/media/ringofsales.a9517e81.jpg";